import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import content, { contentPropTypes } from './FileUploadErrorsBacs.content';
import withContent from '../../containers/withContent';
import { FileUploadRenderContent, CLIENT_SIDE } from './FileUploadRenderContent';

function FileUploadErrorsBacsComponent({ content, formattedData, errorType, maxRecordsLimit, parserErrorMsg }) {
	return (
		<FileUploadRenderContent
			content={content}
			formattedData={formattedData}
			errorType={errorType}
			contentType={CLIENT_SIDE}
			maxRecordsLimit={maxRecordsLimit}
			parserErrorMsg={parserErrorMsg}
		/>
	);
}

FileUploadErrorsBacsComponent.propTypes = {
	formattedData: PropTypes.arrayOf(PropTypes.object).isRequired,
	errorType: PropTypes.string.isRequired,
	maxRecordsLimit: PropTypes.bool,
	content: PropTypes.shape(contentPropTypes).isRequired,
	parserErrorMsg: PropTypes.string.isRequired,
};

export default compose(withContent({ content }))(FileUploadErrorsBacsComponent);
